export default "__VITE_ASSET__GQl5xLRb__"